module.exports = __webpack_public_path__ + "static/media/peace_symbol.346a8b3f.png";